import i18n from '@core/plugins/i18n';
import { HttpController } from '@core/helpers/http';
import * as MutationTypes from './mutationTypes';
import { UserSettings } from './models';
import * as api from './api';

export const userSettingsRequest = async ({ commit }) => {
  const response = await api.userSettingsRequest();
  const settings = UserSettings.toInstance(response.data);
  commit(MutationTypes.USER_SETTINGS_SUCCESS, settings);
  i18n.locale = settings.language;
  HttpController.updateHttpClientLanguage(settings.language);
  return settings;
};

export const updateUserSettingsLanguageRequest = async (context, updatedUserSettings) => {
  const response = await api.updateUserSettingsRequest(updatedUserSettings.serialize());
  const settings = UserSettings.toInstance(response.data);
  context.commit(MutationTypes.USER_SETTINGS_SUCCESS, settings);
  i18n.locale = updatedUserSettings.language;
  HttpController.updateHttpClientLanguage(updatedUserSettings.language);
};
